import React from 'react';
import { Button } from './ui/Button';
import { Calendar, MapPin } from 'lucide-react';
export function EventSection() {
  return <section id="event" className="py-24 bg-[#ecdfd2]/20" data-id="element-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20" data-id="element-26">
          {/* Circular Image */}
          <div className="flex-1 w-full flex justify-center order-2 md:order-1" data-id="element-27">
            <div className="relative" data-id="element-28">
              <div className="absolute inset-0 rounded-full bg-[#d4956a]/20 blur-2xl scale-110" data-id="element-29"></div>
              <div className="relative w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden shadow-2xl ring-4 ring-white" data-id="element-30">
                <img src="https://cdn.magicpatterns.com/uploads/s18Tp6VvAWgddtmmdJSLUq/Downtown-Harrisonburg-VA-.jpg" alt="Downtown Harrisonburg" className="w-full h-full object-cover" data-id="element-31" />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 text-center md:text-left order-1 md:order-2" data-id="element-32">
            <h2 className="text-3xl md:text-4xl font-bold text-[#3b2316] mb-6" data-id="element-33">
              Best Weekend Ever
            </h2>

            <p className="text-xl text-[#5a3a28]/80 leading-relaxed mb-8" data-id="element-34">
              This year in partnership with Harrisonburg Downtown Renaissance,
              we will be recognizing Rockingham County fathers and
              father-figures during the Best Weekend Ever.
            </p>

            <div className="flex flex-col gap-4 mb-8 items-center md:items-start" data-id="element-35">
              <div className="flex items-center gap-3 text-lg text-[#3b2316] font-medium" data-id="element-36">
                <Calendar className="w-6 h-6 text-[#c06a2b]" data-id="element-37" />
                <span data-id="element-38">June 13, 2026</span>
              </div>
              <div className="flex items-center gap-3 text-lg text-[#3b2316] font-medium" data-id="element-39">
                <MapPin className="w-6 h-6 text-[#c06a2b]" data-id="element-40" />
                <span data-id="element-41">Downtown Harrisonburg</span>
              </div>
            </div>

            <Button href="https://www.downtownharrisonburg.org/best-weekend-ever" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-42">
              View Event Details
            </Button>
          </div>
        </div>
      </div>
    </section>;
}